import ButtonYapp from '../Buttons/ButtonYapp'

function ProductPrescription(props) {
  return (
    <>
      <div className="content-add-prescription mb-1">
        <h3 className="text-truncate w-100">{props.product.name}</h3>
        {!props.prescriptionProduct?.find(
          (product) =>
            product?.product_id == props.product?.product_id ||
            product?.product_id == props.product?.client_product_id,
        ) ? (
          <ButtonYapp
            title="Agregar receta"
            onClick={() =>
              props.onClickLoadPrescription(
                props.product.product_id,
                props.products,
              )
            }
            color={'--theme-color'}
            noWrap
            id={`gtm-webapp-checkout-product-prescription${props.product}`}
            className="mw-115"
            small
          />
        ) : (
          <div className="d-flex align-items-center justify-content-end flex-fill">
            <i className="icon-circle-check mr-2 color-theme"></i>
            <p className="txt-paragraph color-theme txt-nowrap">
              ¡Receta agregada!
            </p>
          </div>
        )}
      </div>
      {/* <div className="card-info">
        <div className="d-flex align-items-center text-truncate w-100">
          <span className="txt-paragraph text-truncate w-100">
            {props.product.name}
          </span>
        </div>
        <div
          className="d-flex align-items-center justify-content-end flex-fill"
          style={{minWidth: '100px'}}>
          {!props.prescriptionProduct.find(
            (product) => product.product_id === props.product.product_id,
          ) ? (
            <div
              onClick={() =>
                props.onClickLoadPrescription(
                  props.product.product_id,
                  props.products,
                )
              }>
              <div
                id={`gtm-webapp-checkout-product-prescription${props.product}`}
                className="txt-paragraph color-theme">
                + Agregar receta
              </div>
            </div>
          ) : (
            <div className="d-flex align-items-center justify-content-end flex-fill">
              <i className="icon-check mr-2 color-theme"></i>
              <p className="txt-paragraph color-theme">¡Receta agregada!</p>
            </div>
          )}
        </div>
      </div> */}
    </>
  )
}

export default ProductPrescription
